const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/edeliverych/api-factory');
const merge = require('lodash/fp/merge');
const serviceFactory = require('../resources/edeliverych/service-factory');
const parseRequestMetaData = require('../utils/parse-request-meta-data');
const base64 = require('base-64');
const headers = { Accept: 'application/json' };
function parseValueMovement(data) {
  if((!data) || data.length==0){
    return null;
   }
   else {
     return JSON.stringify(data);
   }
}


function downLoadExcelContent ({ metaData, requestBody}, requestHandler) {
  const meta = parseRequestMetaData(metaData);
  const params = requestBody.split('#@#');
  const decodedpfIdParam = base64.decode(params[0]);
  const pfIdStringArray = decodedpfIdParam.split('$');
  // const pfIdNumberArray = pfIdStringArray.map(Number);WMCE-8989 commented to accomodate alphanumeric PF id
  const branchCode = meta.portfolio.branchCode === 999999999? meta.configBranchCode : meta.portfolio.branchCode;
  const parsedRequestBody = JSON.parse(base64.decode(params[1]));

  const request = {
    method: 'POST',
    url: `${config.baseUrl}/excelexports/${apiConfig.apiversion}/excel-content`,
    Accept: 'application/json',
    headers: merge(headers, meta.headers),
    body: {
      userId: meta.qs.userId,
      branchCode: branchCode,
      fromDate: parsedRequestBody.fromDate,
      reportname: parsedRequestBody.reportname,
      toDate: parsedRequestBody.toDate,
      pfId: pfIdStringArray,
      fileType: parsedRequestBody.fileType || null
    },
    json: true,
  }
  // serialize
  return requestHandler(request)
    .then(parseValueMovement)
    .catch(() => null)
}

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/edelivery/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}edelivery.initializeEDelivery[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.initializeEDelivery(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}edelivery.handleDocuments`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.handleDocuments(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}edelivery.markDocumentsAsRead[{keys:inputParam}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.markDocumentsAsRead(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
      .match(`${p}edelivery.downloadDocuments[{keys:inputParam}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.downloadDocuments(req.params)
            .then(response => res.value(response))
            .catch(res.error)
        )))
      
      .match(`${p}edelivery.reports.statementTypes[{keys:guidStr}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
        service.getStatementTypes(req.params)
          .then(response => res.value(response))
          .catch(res.error)
        )))
      .match(`${p}edelivery.reports.createAdhocReport[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
        service.createAdhocStatementReport(req.params)
          .then(response => res.value(response))
          .catch(res.error)
        )))
      .match(`${p}edelivery.fetchDocumentsForCategories[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.fetchDocumentsForCategories(req.params)
            .then(response => res.value(response))
            .catch(res.error)
        )))
      .match(`${p}edelivery.fetchDocumentsForOrder[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.fetchDocumentsForOrder(req.params)
            .then(response => res.value(response))
            .catch(res.error)
        )))
        .match(`[{keys:metaData}].edelivery.positionDownloads.downloads[{keys:requestBody}].[{keys:ran_str}]`, requests => Promise.all(
        requests.map(
            ({ req, res }) => downLoadExcelContent(req.params, requestHandler)
            .then(response => res.value(response))
            .catch(res.error)
          )))

       .match(`${p}edelivery.fetchDocuments[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
            requests.map(({ req, res }) =>
              service.fetchDocuments(req.params)
                .then(response => res.value(response))
                .catch(res.error)
          )))
}

module.exports = addRoutes;
